import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import PublicFrame, { usePublicBranding } from "./PublicFrame";

export default function JoinTeam() {
  const { slug } = useParams();
  const [info, setInfo] = useState(null);
  const [f, setF] = useState({ name: "", email: "", phone: "", gender: "", treatments: "", areas: "", experience: "" });
  const [file, setFile] = useState(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  usePublicBranding(info);
  useEffect(() => { api.get(`/public/c/${slug}/clinic`).then((r) => setInfo(r.data)); }, [slug]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const fd = new FormData();
      Object.entries(f).forEach(([k, v]) => fd.append(k, v));
      if (file) fd.append("file", file);
      await api.post(`/public/c/${slug}/home/apply`, fd); setDone(true);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <PublicFrame branding={info?.branding}>
      {done ? <div className="py-16 text-center space-y-3" data-testid="join-team-done"><CheckCircle2 className="h-12 w-12 text-primary mx-auto" /><h1 className="text-3xl">Application sent</h1><p className="text-muted-foreground">We'll review it and get back to you by email.</p></div> : (
        <form onSubmit={submit} className="space-y-3 max-w-lg" data-testid="join-team-form">
          <div><p className="text-xs uppercase tracking-[0.18em] text-muted-foreground">Work with us</p><h1 className="text-3xl sm:text-4xl">Join our team</h1>
            <p className="text-muted-foreground mt-2">Choose the areas you want to work in and set your own availability.</p></div>
          <Input required data-testid="jt-name" placeholder="Full name" value={f.name} onChange={set("name")} />
          <div className="grid sm:grid-cols-2 gap-2"><Input required type="email" data-testid="jt-email" placeholder="Email" value={f.email} onChange={set("email")} /><Input required data-testid="jt-phone" placeholder="Phone" value={f.phone} onChange={set("phone")} /></div>
          <select className="h-10 w-full rounded-md border bg-background px-3 text-sm" data-testid="jt-gender" value={f.gender} onChange={set("gender")}><option value="">Gender (optional)</option><option value="female">Female</option><option value="male">Male</option></select>
          <Input data-testid="jt-treatments" placeholder="Treatments you offer (e.g. sports massage, osteopathy)" value={f.treatments} onChange={set("treatments")} />
          <Input data-testid="jt-areas" placeholder="Postcode areas you want to cover (e.g. W1, SW3, NW8)" value={f.areas} onChange={set("areas")} />
          <Textarea data-testid="jt-experience" rows={4} placeholder="Qualifications, registration number, insurance, experience" value={f.experience} onChange={set("experience")} />
          <label className="block text-sm">Qualification or insurance document (PDF or photo, optional)
            <input type="file" data-testid="jt-file" accept=".pdf,image/*" className="mt-1 block text-sm" onChange={(e) => setFile(e.target.files[0])} /></label>
          <Button className="rounded-full w-full" data-testid="jt-submit" disabled={busy}>{busy ? "Sending…" : "Send application"}</Button>
        </form>)}
    </PublicFrame>
  );
}
